










































































import DatasourceServices, { DatasourceDto } from '@/services/datasource';
import { Vue,Component, PropSync, Prop, Watch } from 'vue-property-decorator';
import SelectRole from './select-role.vue'
import SelectUser from './select-user.vue'

@Component({
  components:{ SelectRole, SelectUser,}
  })
export default class ColumnConfig extends Vue {
  @PropSync('tableId') syncTableId! : number;
 
  data: any[] = [];
  dsSrv = new DatasourceServices();
  childShow = true;
  visible = false;
  selectedRowKeys:number[] = [];
  objectType = "user";
  ObjectTitle = "用户";
  
  showSelectUser = false;
  showSelectRole = false;
  
  columns = [{
    // title: this.ObjectTitle,
      dataIndex: 'objectName',
      key: 'objectName',
      width: 120,
      scopedSlots:{title: 'title1'}
    },
    {
      title: '允许访问数据',
      dataIndex: 'queryPermission',
      key: 'queryPermission',
      width: 80,
      scopedSlots: { customRender: 'switch' },
    },
    {
      title: '允许修改数据',
      dataIndex: 'editPermission',
      key: 'editPermission',
      width: 80,
      scopedSlots: { customRender: 'switch' },
    },
    {
      title: '允许创建数据',
      dataIndex: 'createPermission',
      key: 'createPermission',
      width: 80,
      scopedSlots: { customRender: 'switch' },
    },
    {
      title: '操作',
      dataIndex: 'operation',
      key: 'operation',
      width: 50,
      scopedSlots: { customRender: 'operation' },
    },
  ];
  mounted() {

    this.getDataList();
  }

  @Watch("")
  onSelectChange(selectedRowKeys: []) {
    this.selectedRowKeys = selectedRowKeys;
  }
  // @Watch("syncTableId")
  // onSyncTableIdChange() {
  //   if (this.syncTableId) {
  //     this.getDataList();
  //   } else {
  //     // this.data = []
  //   }
  // }

  onClose(type : string) {
    this.$emit("onClose", type)
  }
  async onDelete(ids: number[]) {
    let res = await this.dsSrv.deletePermissions(ids);
    this.getDataList();
  }
  async onCellChange(args: string[], record:any) {
    let cfg = {...record}
    let res = await this.dsSrv.updatePermission(cfg)
    record.columnNameCn = args[0]
  }
  /** 选择类型 */
  async tabChanged(key: string) {
    this.objectType = key;
    this.ObjectTitle = key === 'user'? '用户': '角色';
    this.getDataList();
  }
  async getDataList() {
    
    this.data = await this.dsSrv.permissions({tableId_eq: this.syncTableId, objectType_eq: this.objectType});

  }

  /**选择用户角色操作 **/
  showSelect() {
    if (this.objectType === 'user') {
      this.showSelectUser = true;
    } else {
      this.showSelectRole = true;
    }
  }
  async userSelected(args:any[]) {
    let perms = []
    
    for (let item of args[0] ) {
      perms.push({status:0, tableId: this.syncTableId, objectType: 'user',
        objectCode: item.staffCode, objectName: item.userName, 
        queryPermission: 1, editPermission: 1, createPermission: 1 })
    }
    await this.dsSrv.savePermissions(perms);
    this.getDataList();
    
  }
  async roleSelected(args: any[]) {
    let perms = []
    
    for (let item of args[0] ) {
      perms.push({status:0, tableId: this.syncTableId, objectType: 'role',
        objectCode: item.roleCode, objectName: item.roleName, 
        queryPermission: 1, editPermission: 1, createPermission: 1 })
    }
    await this.dsSrv.savePermissions(perms);
    this.getDataList();
  }
  handleBatch(args: any) {
    if (args.key == 'removeAll') {
      this.onDelete(this.selectedRowKeys);
    }
  }

}
